import React from "react";

import SectionFigure from "./SectionFigure";

export default function Section(props) {
  return (
    <>
      <section className="section-spacing" id={props.sectionID}>
        <div className="container">
          <h2 className="heading-secondary">{props.sectionHeading}</h2>

          <div className="container-figure">
            <div className="grid grid--2-cols grid--2-rows">
              <SectionFigure
                heading="Lisbon Chair Shop"
                listItem1="A small chair shop, located at the heart of Lisbon City"
                listItem2="We believe in astonishing quality experience"
                listItem3="Find right chair to keep your body comfortable"
                appURL="https://lisbonchairsbyjayant.netlify.app/"
              />
              <SectionFigure
                figGridPlacement="row-2--col-2"
                heading="Omnifood"
                listItem1="A smart 365-days-per-year food subscription"
                listItem2="Best chefs in town at your service every day"
                listItem3="No time for cooking? Visit us"
                appURL="https://jayant-omnifood.netlify.app/"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
